// extracted by mini-css-extract-plugin
module.exports = {"solutions":"Solutions_solutions__YwVfi"};